import Avatar from '@components/ui/Avatar';
import { usePublicConfig } from '@context/PublicConfigContext';
import { resolveAvatarUrlString } from '@utils/profileImageSrc';
import { formatInboxTime } from '@utils/helpers';
import { INBOX_READ_ROW, INBOX_ROW_FRAME, INBOX_UNREAD_ROW } from '@components/messages/inboxRowStyles';

/**
 * @param {{
 *   conversation: {
 *     activityId: string,
 *     senderName: string,
 *     senderAvatar?: string,
 *     activityName: string,
 *     lastMessage: string,
 *     time: string,
 *     sortAt?: string,
 *     previewAt?: string,
 *     isUnread: boolean,
 *   },
 *   onClick: () => void,
 *   isPulsing?: boolean,
 * }} props
 */
const MessageCard = ({ conversation, onClick, isPulsing = false }) => {
  const { siteOrigin } = usePublicConfig();
  const { senderName, senderAvatar, activityName, lastMessage, time, previewAt, isUnread } = conversation;
  const timeLabel = formatInboxTime(previewAt ?? time);

  const chrome =
    `${INBOX_ROW_FRAME} group ease-out focus:outline-none focus-visible:ring-2 focus-visible:ring-surface-400/50 dark:focus-visible:ring-surface-500/35`;

  return (
    <button
      type="button"
      onClick={onClick}
      className={`${chrome} ${isUnread ? INBOX_UNREAD_ROW : INBOX_READ_ROW} ${
        isPulsing ? 'animate-pulse-glow' : ''
      }`}
    >
      <Avatar name={senderName} src={resolveAvatarUrlString(senderAvatar, siteOrigin)} size="md" className="shrink-0" />
      <div className="min-w-0 flex-1">
        <div className="flex items-start justify-between gap-2">
          <p className="truncate text-[15px] font-semibold text-surface-900 dark:text-surface-50">
            <span>{senderName}</span>
            <span className="mx-1.5 font-normal text-surface-400 dark:text-surface-500">·</span>
            <span className="font-medium text-violet-600 dark:text-violet-400">{activityName}</span>
          </p>
          <span className="shrink-0 text-xs tabular-nums text-surface-400 dark:text-surface-500">
            {timeLabel}
          </span>
        </div>
        <p
          className={`mt-1 truncate text-sm leading-snug ${
            isUnread
              ? 'text-surface-700 dark:text-surface-200'
              : 'text-surface-500 opacity-80 dark:text-surface-400 dark:opacity-75'
          }`}
        >
          {lastMessage}
        </p>
      </div>
    </button>
  );
};

export default MessageCard;
